module.exports = __webpack_public_path__ + "34736292/img/note-edit-icon.acae1669.svg";